
/**
 * Realiza um scroll suave até uma posição específica com duração controlada.
 * @param targetY A posição Y de destino
 * @param duration Duração em milissegundos (padrão 2000ms para efeito cinematográfico)
 */
export const customSmoothScroll = (targetY: number, duration: number = 2000) => {
  const startY = window.pageYOffset;
  const difference = targetY - startY;
  let start: number | null = null;

  const step = (timestamp: number) => {
    if (!start) start = timestamp;
    const progress = timestamp - start;
    const percent = Math.min(progress / duration, 1);
    
    // Função de Easing: easeInOutQuint (mais fluida e dramática que a Quart)
    const easing = percent < 0.5 
      ? 16 * percent * percent * percent * percent * percent 
      : 1 - Math.pow(-2 * percent + 2, 5) / 2;

    window.scrollTo(0, startY + difference * easing);

    if (progress < duration) {
      window.requestAnimationFrame(step);
    }
  };

  window.requestAnimationFrame(step);
};

/**
 * Calcula a posição de destino descontando a altura da navbar.
 */
export const getScrollTargetPosition = (targetId: string): number => {
  const targetElement = document.getElementById(targetId);
  if (!targetElement) return 0;

  if (targetId === 'inicio') return 0;

  const navbarElement = document.querySelector('nav.fixed') as HTMLElement;
  const navbarHeight = navbarElement ? navbarElement.offsetHeight : 0;
  const elementTop = targetElement.getBoundingClientRect().top + window.scrollY;
  
  // Margem de respiro de 30px para não colar no topo
  return elementTop - navbarHeight - 30;
};
